<template>
  <div>
    <div class="px-3 position-relative" id="tvmServiceCoupons">
      <VSlickCarousel v-if="serviceOffersData != null && serviceOffersData.length" ref="slick" v-bind="slickOptions"
        @afterChange="handleAfterChange" @init="handleInit">
        <template #nextArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-right-arrow"
            :style="getArrowStyles('right')"></em>
        </template>
        <div v-for="(serviceDescText, index) in serviceOffersData" :key="index" class="p-2 text-center">
          <div v-if="componentObj.isButtonEnabled"
            class="service__types__btn__cont color-primary p-1 bg-white rounded-box theme-text-color position-relative"
            :class="[serviceDescText.isSelected ? 'selected-box' : '']" :style="{
              border:
                serviceDescText.isSelected && chatThemeSettings && chatThemeSettings.primeColor
                  ? '2px solid ' + primaryColor
                  : '1px solid ' + (chatThemeSettings?.borderColor || '#eee'),
            }" @click.prevent="onCouponSelected(serviceDescText, index)">
            <div v-if="serviceDescText.isAppleMobile" class="position-absolute appleWallet-position">
              <a class="appleWallet"
                :href="`${serviceDescText.appleWalletAPIUrl}/${serviceDescText.templateId}/${serviceDescText.serialNumber}`"
                @click="onAppleWalletClick(serviceDescText.offerId)">
                <img :id="serviceDescText.offerId" src="/images/addToAppleWallet.svg" :offerid="serviceDescText.offerId"
                  :templateid="serviceDescText.templateId" :serialnumber="serviceDescText.serialNumber"
                  class="appleWalletImgBtn" :alt="serviceDescText.heading" :title="serviceDescText.heading" />
              </a>
            </div>

            <Transition>
              <div v-if="serviceDescText.isSelected" class="custom-check-box">
                <span class="primaryicon-financing" />
              </div>
            </Transition>

            <a class="service__types__btn">
              <span class="service__types__btn__iconBox mt-3">
                <img
                  :src="`https://service.secureoffersites.com/images/getlibraryimage?fileNameOrId=${serviceDescText.imageId}&amp;height=60`"
                  class="img-fluid" alt="add To Apple Wallet" />
              </span>
              <div class="card-min-height">
                <p v-if="serviceDescText.heading" :title="serviceDescText.heading"
                  class="service__types__btn__title text-capitalize text-dark theme-text-color text-ellipsis">
                  <span v-html="serviceDescText.heading" />
                </p>

                <p v-if="serviceDescText.amountText"
                  class="service__types__btn__title text-capitalize text-dark theme-text-color">
                  <span>
                    <b class="_theme_font_bold color-black" v-html="serviceDescText.amountText" />
                  </span>
                </p>

                <p v-if="serviceDescText.description" :title="serviceDescText.description"
                  class="service__types__btn__title text-dark theme-text-color">

                  <span>
                    <span v-html="serviceDescText.description" />
                  </span>
                </p>

                <div class="text-center py-1" style="line-height: 0.5">
                  <span class="no-hover ft-10 color-black text-underline"
                    @click.stop="viewDetails(serviceDescText)">View
                    Details</span>
                </div>
              </div>
              <div class="w-100 px-1 d-flex align-items-center justify-content-center">
                <span
                  class="text-white service__types__btn__title select_btn select_btn rounded-buttons font-weight-bold bgcolor-primary opacity_7"
                  :class="{ 'bgcolor-primary text-white opacity-1': serviceDescText.isSelected }">
                  {{ serviceDescText.isSelected ? "Selected" : "Select" }}
                </span>
              </div>
            </a>
          </div>
          <div v-else
            class="service__types__btn__cont color-primary p-3 bg-white h-100 shadow-sm rounded-box theme-text-color position-relative"
            :class="[serviceDescText.isSelected ? 'selected-box' : '']" :style="{
              border:
                serviceDescText.isSelected && chatThemeSettings && chatThemeSettings.primeColor
                  ? '2px solid ' + primaryColor
                  : '0px solid ' + (chatThemeSettings?.borderColor || '#eee'),
            }">
            <div v-if="serviceDescText.isAppleMobile" class="position-absolute appleWallet-position">
              <a class="appleWallet"
                :href="`${serviceDescText.appleWalletAPIUrl}/${serviceDescText.templateId}/${serviceDescText.serialNumber}`"
                @click="onAppleWalletClick(serviceDescText.offerId)">
                <img :id="serviceDescText.offerId" src="/images/addToAppleWallet.svg" :offerid="serviceDescText.offerId"
                  :templateid="serviceDescText.templateId" :serialnumber="serviceDescText.serialNumber"
                  class="appleWalletImgBtn" :alt="serviceDescText.heading" :title="serviceDescText.heading" />
              </a>
            </div>

            <Transition>
              <div v-if="serviceDescText.isSelected" class="custom-check-box">
                <span class="primaryicon-financing" />
              </div>
            </Transition>

            <a class="ai_offer_img">
              <span>
                <img
                  :src="`https://service.secureoffersites.com/images/getlibraryimage?fileNameOrId=${serviceDescText.imageId}&amp;`"
                  class="img-fluid" alt="addToAppleWallet" />
              </span>
              <div class="card-min-height mt-3">

                <p v-show="serviceDescText.preText" class="mb-0">
                  <span class="text-dark theme-text-color ft-14">{{ serviceDescText.preText }}</span>
                </p>

                <p v-if="serviceDescText.heading" :title="serviceDescText.heading"
                  class="text-capitalize text-dark theme-text-color text-ellipsis mb-0">
                  <b class="_theme_font_bold ft-16  color-black">{{ serviceDescText.heading }}</b>
                </p>

                <p v-if="serviceDescText.amountText"
                  class="service__types__btn__title text-capitalize text-dark theme-text-color">
                  <span>
                    <b class="_theme_font_bold color-black" v-html="serviceDescText.amountText" />
                  </span>
                </p>

                <p v-if="serviceDescText.description" :title="serviceDescText.description"
                  class="service__types__btn__title text-dark theme-text-color">
                  <span>
                    <span class="ft-14" v-html="serviceDescText.description" />
                  </span>
                </p>
              </div>
              <div class="text-center py-1" style="line-height: 0.5">
                <span class="no-hover ft-12 cursor-pointer color-black text-underline"
                  @click.stop="viewDetails(serviceDescText)">View
                  Details</span>
              </div>
            </a>
          </div>
        </div>
        <template #prevArrow="arrowSlotProps">
          <em :disabled="arrowSlotProps.disabled" @click="arrowSlotProps.onClick" class="primaryicon-left-arrow"
            :style="getArrowStyles('left')"></em>
        </template>
      </VSlickCarousel>
      <div v-if="serviceOffersData?.length > 3" class="ft-12 page_counter">
        {{ currentSlide }} of {{ serviceOffersData?.length }}
      </div>
      <!-- custom modal -->
      {{ design }}

      <template v-if="viewDetailsModal">
        <div id="viewDetailsModal" class="modal" :style="{ display: viewDetailsModal ? 'block' : 'none' }">
          <div class="modal-dialog">
            <div class="modal-content">
              <!-- Modal Header -->
              <div class="modal-header align-items-center">
                <h6 class="m-0 _theme_font_bold">Disclosure</h6>
                <div>
                  <button type="button" aria-label="Close" class="close" @click.prevent="viewDetailsModal = false">
                    ×
                  </button>
                </div>
              </div>
              <div class="p-3 scroll-wrap">
                <p v-if="viewDetailsData.disclaimerText">
                  <span v-html="viewDetailsData.disclaimerText" />
                </p>
                <p v-if="viewDetailsData.formattedEndDate" class="m-0">
                  - Expires:
                  <b class="color-primary theme-text-color">{{ viewDetailsData.formattedEndDate }}</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop show" />
      </template>
      <!-- end custom modal -->
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import {
  chatWidgetAscCommEngagement,
  chatWidgetCouponsSpecialOffer,
  fireSelectedCoupons,
} from '../../../../Events/TagManagerServices/TaggingEventForPages';
import { Events } from '../../../../Events/ConsumerEvents/Events';
import 'v-slick-carousel/style.css';
import { VSlickCarousel } from 'v-slick-carousel';
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
import TvmPreLoader from '../../TvmPreLoader/TvmPreLoader.vue';
export default {
  data() {
    return {
      primaryColor: window.primaryColor,
      viewDetailsModal: false,
      viewDetailsData: '',
      isLoader: false,
      displayText: 'Please Wait Data is Loading...',
      isDisableChat: false,
      isHeading: false,
      serviceOffersData: [],
      serviceTypesPayloadUrl: '',
      buttons: [],
      btnDisabled: true,
      selectedCoupon: '',
      currentSlide: 1,
      slickOptions: {
        infinite: false,
        groupsToShow: 5,
        groupsToScroll: 1,
        dots: false,
        infiniteLoopOnEdge: true,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 1,
            },
          },
        ],
      },
      selectedCouponIndex: null,
    };
  },
  components: {
    'tvm-pre-loader': TvmPreLoader,
    VSlickCarousel,
  },
  props: [
    'botResponse',
    'isLastIndex',
    'index',
    'countCoupons',
    'isWaitingForResponse',
    'chatThemeSettings',
    'design'
  ],
  computed: {
    componentObj() {
      return this.botResponse?.component?.value;
    },
  },
  mounted() {
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }
    let payload = this.botResponse?.component?.value;
    this.buttons = this.botResponse?.component?.value?.suggestions;

    if (this.design && this.design == 1) {
      this.slickOptions.groupsToShow = 4;
    }

    axios
      .get(payload.couponsUri)
      .then((response) => {
        let items = response.data;
        this.serviceTypesPayloadUrl = payload.couponsUri;
        items.forEach((value) => {
          chatWidgetCouponsSpecialOffer(value);
          value.isSelected = false;
        });
        if (items.length) {
          let selectedServiceOffers = JSON.parse(sessionStorage.getItem('serviceOffersData')) || [];
          selectedServiceOffers.forEach((val) => {
            if (val.index === this.countCoupons) {
              let selectedId = val.id;
              items[selectedId].isSelected = true;
              setTimeout(() => {
                if (this.$refs.slick) {
                  this.$refs.slick.goTo(selectedId);
                }
              }, 500);
            }
          });
        }
        this.serviceOffersData = items;
        this.scrollBottom();

        if (items.length > 3) {
          this.slickOptions.dots = true;
        }
      })
      .catch((error) => {
        console.log(error);
        this.displayText = 'Something Went wrong. Please try again';
      });
  },
  beforeDestroy() {
    this.$root.$off('isWaitingForResponseData');
  },
  methods: {
    trucate(value, length = 15) {
      return value.length <= length ? value : value.substring(0, length) + '...';
    },
    optionclick(event, button, offer, idx) {
      this.$root.$emit('isWaitingForResponseData', true);

      let postObject = {
        eventname: button.event,
        text: button.name,
      };
      if (offer?.offerId) {
        let Obj = { id: idx, index: this.countCoupons };
        let selectedServiceOffers = JSON.parse(sessionStorage.getItem('serviceOffersData')) || [];
        selectedServiceOffers.push(Obj);
        sessionStorage.setItem('serviceOffersData', JSON.stringify(selectedServiceOffers));
        postObject.OfferSelection = {
          OfferId: offer.offerId,
          OfferCategoryId: offer.offerTypeID,
          OfferDesignId: offer.offerDesignId,
        };
      }
      ChatWidgetService.postTvmMessage(
        `${button.name} ${offer?.heading ? ':' + offer.heading : ''}`,
        button.event,
        button.submitFlow,
        button.submitAction,
        postObject
      );
      chatWidgetAscCommEngagement(event, {}, false);
    },
    viewDetails(val) {
      this.viewDetailsModal = true;
      this.viewDetailsData = val;
      fireSelectedCoupons(val.heading);
    },
    scrollBottom() {
      let container = document.querySelector('#chat__bodyview');
      if (container) {
        setTimeout(() => {
          container.scrollTop = container.scrollHeight;
        }, 500);
      }
    },
    onAppleWalletClick(offerid, styleid) {
      Events.specialsEvent(Events.eventsConstants.AppleWallet, styleid, '', offerid);
    },
    onCouponSelected(serviceType, idx) {
      let isSelected = serviceType.isSelected;
      this.serviceOffersData.forEach((value) => {
        value.isSelected = false;
      });
      this.serviceOffersData[idx].isSelected = !isSelected;
      this.selectedCoupon = this.serviceOffersData[idx].isSelected
        ? this.serviceOffersData[idx]
        : '';
      this.selectedCouponIndex = this.serviceOffersData[idx].isSelected ? idx : null;
    },
    handleAfterChange(currentSlideGroupIndex) {
      console.log(currentSlideGroupIndex);
      if (window.ismobile) {
        this.currentSlide =
          currentSlideGroupIndex === 0
            ? 2
            : currentSlideGroupIndex + this.slickOptions.groupsToShow;
      } else {
        this.currentSlide =
          currentSlideGroupIndex === 0
            ? 5
            : currentSlideGroupIndex + this.slickOptions.groupsToShow;
      }
    },
    handleInit(event, slick, currentSlide) {
      this.currentSlide = window.ismobile ? 2 : this.slickOptions.groupsToShow;
    },
    getArrowStyles(direction) {
      const commonStyles = {
        cursor: 'pointer',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: this.primaryColor,
        color: '#fff',
        zIndex: 10,
      };
      if (direction === 'left') {
        return {
          ...commonStyles,
        };
      } else if (direction === 'right') {
        return {
          ...commonStyles,
        };
      }
      return commonStyles;
    },
  },
};

</script>
<style lang="less">
#tvmServiceCoupons :deep(.modal) {
  position: absolute !important;
  margin: 10px;
}

#tvmServiceCoupons :deep(.modal-body) {
  padding: 0px;
}

#tvmServiceCoupons :deep(.modal-header) {
  padding: 5px;
}

#tvmServiceCoupons :deep(.modal-title) {
  text-transform: capitalize;
}

#tvmServiceCoupons:deep(.modal-backdrop) {
  position: absolute !important;
}


.ai_offer_img {
  img {
    height: 150px;
    object-fit: cover;
    border-radius: 6px;
    width: 100%;
  }
}

.card-min-height {
  min-height: 200px;
}

.page_counter {
  position: absolute;
  right: 2%;
  bottom: 2%;
  font-weight: bold;
  border-left: 1px solid #e1e1e1d7;
  padding-left: 10px;
  line-height: 1;
}
</style>
